/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BookingSuspendedReason = {
    AlreadyOverCreditLimit: 'AlreadyOverCreditLimit',
    OverdueInvoices: 'OverdueInvoices',
    NotSuspended: 'NotSuspended',
    WillBeTooFarBeyondCreditLimit: 'WillBeTooFarBeyondCreditLimit',
    NeedsAccountVerification: 'NeedsAccountVerification',
    AccountOnHold: 'AccountOnHold'
} as const;
export type BookingSuspendedReason = typeof BookingSuspendedReason[keyof typeof BookingSuspendedReason];


export function instanceOfBookingSuspendedReason(value: any): boolean {
    for (const key in BookingSuspendedReason) {
        if (Object.prototype.hasOwnProperty.call(BookingSuspendedReason, key)) {
            if (BookingSuspendedReason[key as keyof typeof BookingSuspendedReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingSuspendedReasonFromJSON(json: any): BookingSuspendedReason {
    return BookingSuspendedReasonFromJSONTyped(json, false);
}

export function BookingSuspendedReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingSuspendedReason {
    return json as BookingSuspendedReason;
}

export function BookingSuspendedReasonToJSON(value?: BookingSuspendedReason | null): any {
    return value as any;
}

export function BookingSuspendedReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingSuspendedReason {
    return value as BookingSuspendedReason;
}

